// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ac18de19","389":"1f5a3e30","732":"cea93fe2","857":"98ef67f8","977":"c4116244"}[chunkId] + ".chunk.js";
};